import { useScanFlow } from "crossdock/common/flow/useScanFlow";
import { createBoxBreakScanAnyUnitCard } from "../../../boxBreakCardCreators";

export function useBackToScanAny() {
  const { addFlowCard } = useScanFlow();
  return () => {
    addFlowCard(createBoxBreakScanAnyUnitCard({}));
  };
}
